var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollectbookTag02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 16,
    viewBox: "0 0 43 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_collectbook_tag_02",
    clipPath: "url(#clip0_2496_32282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18164 0.727273C4.16502 0.727273 0.908913 3.98338 0.908913 8C0.908913 12.0166 4.16502 15.2727 8.18164 15.2727H34.3635C38.3801 15.2727 41.6362 12.0166 41.6362 8C41.6362 3.98338 38.3801 0.727273 34.3635 0.727273H8.18164ZM0.181641 8C0.181641 3.58172 3.76336 0 8.18164 0H34.3635C38.7817 0 42.3635 3.58172 42.3635 8C42.3635 12.4183 38.7817 16 34.3635 16H8.18164C3.76336 16 0.181641 12.4183 0.181641 8Z",
    fill: "#938F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.988 10.5641V11.4782H12.7715V10.5641H16.3119V9.09797H13.7454V6.15875H18.9206V5.04071H13.7313V4.1477H20.014V7.03418H14.8494V8.1944H20.2214V9.09797H17.4088V10.5641H20.988ZM26.634 4.31997V5.20595H25.843V7.86041C26.2367 7.82876 26.62 7.7936 26.989 7.7479L27.0664 8.56709C25.2593 8.86592 23.1884 8.90109 21.6696 8.89757L21.5465 8.00455C21.87 8.00455 22.2181 8.00103 22.5838 7.99401V5.20595H21.7926V4.31997H26.634ZM22.9036 12.3466V9.5269H24.0041V11.4501H29.0142V12.3466H22.9036ZM23.6526 7.9729C24.0217 7.96236 24.3979 7.94829 24.7742 7.9272V5.20595H23.6526V7.9729ZM27.5516 10.1562V3.54297H28.6626V6.13765H29.9177V7.05879H28.6626V10.1562H27.5516Z",
    fill: "#938F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2496_32282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1818,
    height: 16,
    fill: "white",
    transform: "translate(0.181641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollectbookTag02);
export default __webpack_public_path__ + "static/media/icon_collectbook_tag_02.6c72198f133d65c08b2262fe0833c5c2.svg";
export { ForwardRef as ReactComponent };